import { Container, Grid, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { Box } from '@mui/system'
import BG from './background.svg'

export default function About() {
  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${BG})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          height: '800px',
          marginTop: '0px',
        }}
        id="home"
      >
        <Container
          sx={{ color: 'white', textAlign: 'center', paddingTop: '200px' }}
          pt={15}
        >
          <Typography
            fontSize={{ xs: '28px', md: '48px' }}
            sx={{
              fontWeight: '400',
              letterSpacing: '16%',
              textAlign: 'center',
            }}
          >
            Defi Exchange{' '}
            <Box
              sx={{ color: '#E32FF5' }}
              fontSize={{ xs: '28px', md: '48px' }}
            >
              coming soon!
            </Box>
          </Typography>

          <Typography
            fontSize={{ xs: '80px', md: '200px', lg: '250px' }}
            sx={{
              fontWeight: '400',
              letterSpacing: '27%',
              textAlign: 'center',
              textShadow: '0px 0px 20px white',
            }}
          >
            Solar
          </Typography>

          <Typography
            paragraph
            fontSize={{ xs: '15px', md: '14px' }}
            sx={{ padding: '10px 0px' }}
          >
            <Link
              to="/preSale"
              style={{
                color: 'white',
                textDecoration: 'none',
                padding: '10px',
                fontWeight: 'bold',
              }}
              className="glow-on-hover"
            >
              {' '}
              Solar PreSale{' '}
            </Link>
          </Typography>
        </Container>
      </Box>
    </>
  )
}
